import { defineComponent as _defineComponent } from 'vue'
import UserNavigation from "../../AdminNavigationContainer.vue";
import { ref, onMounted, onUpdated } from "vue";
import UserListDataService from "@/services/UserListDataService";
import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/home/Loading.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import { store } from "@/store/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const title = ref("User Inquiry By User ID");
const searchValue = ref("");
const userErr = ref("");

/** 初期表示設定 */
onMounted(function () {
  isLoading.value = true;
});

/** 検索処理 */
const goSearch = () => {
  alertMessage.value = "null";
  alertState.value = "neutral";
  isLoading.value = true;
  userErr.value = "";

  if (searchValue.value == "") {
    userErr.value = i18n.t("alt031");
    return;
  }

  const param = {
    userId: searchValue.value,
    isCheckFlg: true
  };

  UserListDataService.getUserInformation(param)
    .then((response: ResponseData) => {
      if (response.data.length > 0) {
        goUserInformation(searchValue.value);
      } else {
        userErr.value = i18n.t("alt032");
      }
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err012");
      alertState.value = "error";
      isLoading.value = false;
    });
};

/** ユーザー情報画面へ遷移 */
const goUserInformation = (userid: string) => {
  store.dispatch("setuserId", userid);
  store.dispatch("setFlg", "Inquiry");
  store.dispatch("setShowPage", "UserInformation");
};

onUpdated(function () {
  isLoading.value = false;
});

const __returned__ = { isLoading, alertMessage, alertState, i18n, title, searchValue, userErr, goSearch, goUserInformation, UserNavigation, Loading, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})